import {authHeader, ApiConfigs} from "../_helpers";

export const productService = {
    getProducts,
    getProductsByCategory,
    getProductsFilter,
    getById,
    getVariantByAttribute,
    update,
    create,
    updateConfig,
    getAllProducts
};

function getProducts(currentPage: string, perPage: string) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url+ ApiConfigs.product.getAll}?per_page=${perPage}&current_page=${currentPage}`, requestOptions)
        .then(
            handleResponse
        );
}

function getProductsFilter(key: string, filter: string, param: any = "") {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url+ ApiConfigs.product.getAll}?pagination=off&key=${key}&value=${filter}${param}`, requestOptions)
        .then(
            handleResponse
        );
}

function getProductsByCategory(id: string, param: any = "") {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { ...authHeader(), "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url+ ApiConfigs.product.getAll}?pagination=off&key=category_id&value=${id}${param}`, requestOptions)
        .then(
            handleResponse
        );
}

function getById(id: string) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.product.getById.replace(':id', id)}`, requestOptions)
        .then(
            handleResponse
        );
}

function update(id: string, payload: object) {
    const requestOptions = {
        credentials : 'include' as RequestCredentials,
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.product.update.replace(':id', id)}`, requestOptions).then(handleResponse);
}

function create(payload: object) {
    const requestOptions = {
        credentials : 'include' as RequestCredentials,
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.product.create}`, requestOptions).then(handleResponse);
}

function getVariantByAttribute(id_product: string, params: string) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.product.getVariantByAttribute.replace(':id', id_product)+params}`, requestOptions)
        .then(
            handleResponse
        );
}

function updateConfig(payload:any ){

    const requestOptions = {
        method: "POST",
        headers: {"Accept": "application/json" },
        credentials : 'include' as RequestCredentials,
        body: payload,
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.product.batchRank}`, requestOptions)
        .then(
            handleResponse
        );

    
}


function getAllProducts(warehouseId:any) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url+ ApiConfigs.product.getAll}?pagination=off&warehouse_id=${warehouseId}`, requestOptions)
        .then(
            handleResponse
        );
}

function handleResponse(response: any) {
    if (!response.ok) {
        if (response.status === 401) {
            // auto logout if 401 response returned from api
            localStorage.removeItem("user");
            location.reload();
        }
        const error = (response && response.message) || response.status || response.statusText;
        return Promise.reject(error);
    }
    return response.json().then((rep: any) => {
        return rep;
    });
}